<template>
  <v-container fluid tag="section">
    <v-row>
      <v-col cols="12" :md="mini ? 3 : 4" :class="$isMobile ? 'size-13' : ''">
        负责人员：
        <span  v-for="(item, idx) in contactsPerson" :key="idx">
          <v-chip class="mr-1" small outlined>
            <span class="font-weight-black">{{item.name}}</span><v-icon right> mdi-account-outline </v-icon>
          </v-chip>
        </span>
      </v-col>
      <v-col cols="12" :md="mini ? 8 : 4" :class="$isMobile ? 'size-13' : ''">
        协同人员：
        <span v-for="(item, idx) in assistPerson" :key="idx">
          <v-chip class="mr-1" small outlined>
            <span class="font-weight-black">{{item.name}}</span><v-icon right> mdi-account-outline </v-icon>
          </v-chip>
        </span>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    name: 'CustomerTeamDetail',
    components: {
    },
    props: {
      contactsPerson: {
        type: Array,
        default: () => ([])
      },
      assistPerson: {
        type: Array,
        default: () => ([])
      },
      mini: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
      }
    }
  }
</script>

<style>
</style>
